import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';
import { categories } from '@/mocks/categories';
import { articleImageMap } from '@/mocks/article-images';

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  const category = categories.find((c) => c.slug === article.category);
  const imageUrl = articleImageMap[article.imageSeq] || articleImageMap['entry-guide-2025'];

  return (
    <Link
      to={`/article/${article.slug}`}
      className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
    >
      <div className="aspect-[16/9] overflow-hidden">
        <img
          src={imageUrl}
          alt={article.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          title={article.title}
        />
      </div>
      <div className="p-5">
        <div className="flex items-center gap-3 mb-3 flex-wrap">
          {category && (
            <span className="bg-primary-100 text-primary-700 text-xs px-2.5 py-1 rounded-md font-medium whitespace-nowrap">
              {category.name}
            </span>
          )}
          <span className="text-foreground-400 text-xs whitespace-nowrap">{article.date}</span>
          <span className="text-foreground-400 text-xs whitespace-nowrap">{article.readTime}</span>
        </div>
        <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
          {article.title}
        </h3>
        <p className="text-foreground-500 text-sm leading-relaxed line-clamp-2">{article.excerpt}</p>
        <div className="flex items-center gap-2 mt-4 flex-wrap">
          {article.tags.slice(0, 3).map((tag) => (
            <span key={tag} className="text-foreground-400 text-xs bg-background-100 px-2 py-0.5 rounded whitespace-nowrap">
              #{tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}